import React from "react";
import "./reactivePasswordValidation.scss";
import { GENERAL_VALIDATION_CONSTANTS } from "../../constants/validation/generalValidationConstants";
import {
  atleast1SpecialChar,
  atleast1UpperCase,
  atleast1LowerCase,
  atleast1Number,
  min8Characters,
} from "../../utils/regex";
import { UTFCodeEnum } from "../../../enums/utfCode.enum";

const {
  AT_LEAST_ONE_LOWERCASE,
  AT_LEAST_ONE_NUMBER,
  AT_LEAST_ONE_UPPERCASE,
  AT_LEAST_ONE_SPECIAL_CHARACTER,
  MINIMUM_8_CHARACTERS,
} = GENERAL_VALIDATION_CONSTANTS;

const { LIGHT_TICK, LIGHT_CROSS } = UTFCodeEnum;

const validations = [
  {
    regex: atleast1LowerCase,
    message: AT_LEAST_ONE_LOWERCASE,
  },
  {
    regex: atleast1UpperCase,
    message: AT_LEAST_ONE_UPPERCASE,
  },
  {
    regex: atleast1Number,
    message: AT_LEAST_ONE_NUMBER,
  },
  {
    regex: atleast1SpecialChar,
    message: AT_LEAST_ONE_SPECIAL_CHARACTER,
  },
  {
    regex: min8Characters,
    message: MINIMUM_8_CHARACTERS,
  },
];

export interface IReactivePasswordValidationProps {
  value?: string;
}

const ReactivePasswordValidation = (
  props?: IReactivePasswordValidationProps
) => {
  const { value } = props || {};

  return (
    <div className="reactive-password-validation">
      {validations.map(({ regex, message }) => {
        const isValid = regex.test(value || "");

        return (
          <li className={`validation-message ${isValid ? "success" : "error"}`}>
            <span className="validation-icon">
              <span className="validation-icon-unicode">
                {isValid ? LIGHT_TICK : LIGHT_CROSS}
              </span>
            </span>
            {message}
          </li>
        );
      })}
    </div>
  );
};

export default ReactivePasswordValidation;
